import React, { Component } from "react";
import { withRouter, Link, NavLink } from "react-router-dom";
import Autocomplete from "react-autocomplete";
import axios from 'axios';
import { SEARCH_URL } from "../constants/path";
import { STEP_TWO_URL } from "../constants/path";
import Popup from "reactjs-popup";
import {TABLET_SIZE} from "../constants/variables";

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "",
			autocompleteData: [],
			helpActive: "main-menu-active-items",
			helpItemsActive: null,
			helpSubItemsActive: null,
			helpItemsBorderBottom: "main-menu-second-row-container",
			menuItems: [],
			activeItems: [],
			actives: {
				"payment-and-purchase": "main-menu-active-items",
				receive: null,
				calender: null,
				functions: null,
				reports: null,
				setting: null
			},
			link: null
		};
		this.handleClick = this.handleClick.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSelect = this.onSelect.bind(this);
		this.getItemValue = this.getItemValue.bind(this);
		this.renderItem = this.renderItem.bind(this);
		this.retrieveDataAsynchronously = this.retrieveDataAsynchronously.bind(this);
	}
	updateItemLink() {
		const that = this;
		if (window.outerWidth <= TABLET_SIZE) {
			that.setState({
				link: "/"
			});
		} else {
			that.setState({
				link: null
			});
		}
	}
	componentWillMount() {
		this.updateItemLink();
	}
	onSelectHandler(value, item) {
		window.location.href = item.link;
		this.setState({ value });
	}
	onChangeHandler(event, value){
		this.setState({ value })
	}
	retrieveDataAsynchronously(searchText){
		const that = this;
		if ( searchText.length <= 2 ) {
			that.setState({autocompleteData: []});
			return false;
		}
		var postData = {
			text: searchText,
			version: 3
		};
		axios.post(SEARCH_URL, postData)
		.then((res) => {
			that.setState({autocompleteData: res.data});
		})
		.catch((err) => {
			console.log("خطایی رخ داده ...");
			that.setState({autocompleteData: []});
			return false;
			// alert(err);
			// console.log("AXIOS ERROR: ", err);
		});
	}
	onChange(e){
		this.setState({
			value: e.target.value
		});
		this.retrieveDataAsynchronously(e.target.value);
	}
	onSelect(val){
		this.setState({
			value: val
		});
	}
	highlighter(keyword, string, mode) {
		const className = (mode === "detail") ? "detail-tag" : "title-tag";
		let words = keyword.split(" ");
		// let stringWord = string.split(" ");
		// for(let i = 0; i <= words.length - 1; i++) {
		// 	for(let j = 0; j <= stringWord.length - 1; j++) {
		// 		if(words[i].length > 2 && words[i] === stringWord[j]) {
		// 			// stringWord[j] = '<b class=`${className}`>' + stringWord[j].toString() + '</b>';
		// 			stringWord[j] = `<b class=${className}>${stringWord[j].toString()}</b>`;
		// 		}
		// 	}
		// }
		// let clearString = stringWord.toString();
		// clearString = clearString.split(',').join(" ");
		// return clearString;

		for (let i = 0; i < words.length; i++) {
			if (words[i] !== "") {
				const startPoint = string.indexOf(words[i]);
				const endPoint = words[i].length + startPoint;
				if (startPoint !== -1) {
					let theFirst = string.substring(0, startPoint);
					let theWord = string.substring(startPoint, endPoint);
					theWord = `<b class="${className}">${theWord.toString()}</b>`;
					const theRest = string.substring(endPoint, string.length + endPoint);
					string = theFirst.toString() + theWord.toString() + theRest.toString();
				}
			}
		}
		return string;
	}
	renderItem(item, isHighlighted){
		const _title = this.highlighter(this.state.value, item.title, 'title');
		const _detail = this.highlighter(this.state.value, item.search_detail, 'detail');
		return (
			<div key={ Math.random() } className = "autocomplete-item-cell-phone" style={{ background: isHighlighted ? 'rgba(188, 224, 253, 0.2)' : 'white' }}>
				<NavLink to={item.link} target={"_self"} className="search-result-item-cell-phone">
					<span className="text-right search-result-item-title-cell-phone" dangerouslySetInnerHTML={{ __html : _title }} />
					<span className="text-right search-result-item-detail-cell-phone pull-left" dangerouslySetInnerHTML={{ __html : _detail }} />
				</NavLink>
			</div>   
		); 
	}
	getItemValue(item){
		return `${item.title}`;
	}
	headerSearch(hide) {
		if (!hide) {
			return (
				<div className="col-6 pull-left">
					<div className="row">
						<div className="col-12 text-right sub-pages-search">
							{/*<input className="search p-3 ml-6 text-right" type="text" placeholder={"سوال خود را اینجا وارد کنید"} />*/}
							<Autocomplete
								className="search ml-6"
								wrapperStyle={{ position: 'relative', zIndex: '100' }}
								inputProps={{ id: 'states-autocomplete-header', placeholder: 'جستجو ...' }}
								getItemValue={ this.getItemValue }
								items={ this.state.autocompleteData }
								renderItem={ this.renderItem }
								renderMenu={ (children) => (children.length === 0) ? <div/> : <div className="menu-cell-phone mt-2"><div className="menu-list-inner-box-cell-phone">{ children }</div></div> }
								value={ this.state.value }
								onChange={ this.onChange }
								onSelect={ this.onSelect }
							/>
						</div>
					</div>
				</div>
			);
		} else {
			return null;
		}
	}
	breadCrumbs(hide) {
		// let pageName = this.props.history.location.pathname.substr(1,this.props.history.location.pathname.length);
		let pageName = '';
		const urlArray = this.props.history.location.pathname.split("/");
		const arrayLength = parseInt(urlArray.length);
		if (arrayLength === 2) {
			pageName = urlArray[1];
		} else if (arrayLength === 4) {
			pageName = urlArray[1];
		} else if (arrayLength === 5) {
			pageName = urlArray[2];
		} else if (arrayLength === 3 && urlArray[1] === "faq") {
			pageName = urlArray[1];
		}
		const pathNames = {
			"payment-and-purchase": "پرداخت و خرید",
			reports: "گزارش‌ها",
			receive: "دریافت ها",
			setting: "تنظیمات",
			calender: "تقویم",
			functions: "کارکردها",
			profileSetting: "تنظیمات حساب کاربری",
			faq: "پرسش های متداول",
			aboutus: "درباره ما",
			contactus: "ارتباط با ما"
		};
		if (!hide) {
			return (
				<div className="row direction-rtl col-12 pr-0 mt-0 mb-0 breadcrumb-container">
					<span className="breadcrumb pr-0">
						{/*{ (pageName.toString() === 'faq') ? null : <div><Link to="/">آموزش گام به گام</Link>/</div> }*/}
						{(pageName.toString() !== "faq") && <div><Link to="/">آموزش گام به گام</Link>/</div>}
						<Link to={`/${pageName}`}>{ pathNames[pageName] }</Link>
						{(urlArray.length === 5) ?<Link to={this.props.history.location.pathname}>{`/${document.title}`}</Link> : null}
					</span>
				</div>
			);
		} else {
			return null;
		}
	}
	componentDidMount() {
		window.addEventListener( "resize", this.updateItemLink.bind(this) );
		let pageName = '/';
		const urlArray = this.props.history.location.pathname.split("/");
		if (urlArray.length === 2) {
			pageName = urlArray[1];
		} else if (urlArray.length === 4) {
			pageName = urlArray[2];
		}
		const pathNames = {
			"payment-and-purchase": "پرداخت و خرید",
			reports: "گزارش‌ها",
			receive: "دریافت ها",
			setting: "تنظیمات",
			calender: "تقویم",
			functions: "کارکردها",
		};
		document.title = pathNames[pageName] || "راهنمای مپسا-نرم افزار رایگان مدیریت پروژه های ساختمانی و حسابداری پروژه";
		axios.get(STEP_TWO_URL)
			.then(resulte => {
				// return resulte.json();
				return resulte.data;
			}).then(data => {
			this.setState({menuItems: data});
		});
	}
	handleClick() {
		return false;
		// if (this.state.helpActive === null) {
		// 	this.setState({
		// 		helpActive: 'main-menu-active-items',
		// 		helpItemsActive: null,
		// 	});
		// } else {
		// 	this.setState({
		// 		helpActive: null,
		// 		helpItemsActive: "d-none",
		// 		helpSubItemsActive: "d-none"
		// 	});
		// }
	}
	linkHandleClick() {
		// this.forceUpdate();
	}
	subItemsHandleClick(itemName) {
		const actives = {
			"payment-and-purchase": null,
			receive: null,
			calender: null,
			functions: null,
			reports: null,
			setting: null
		};
		actives[itemName] = "main-menu-active-items";
		if (this.state.helpSubItemsActive === "d-none") {
			const items = this.state.menuItems[itemName].map((items, key) => {
				console.log(items);
				return (
					<div className="pt-3" key={key}>
						<Link className="main-menu-active-items" target={"_self"} to={items.data[0].link + items.link + "/" + items.data[0].text.split(" ").join("-") + "/" + items.data[0].id}>
							{items.title}
						</Link>
					</div>
				);
			});
			this.setState({
				helpSubItemsActive: null,
				helpItemsBorderBottom: "main-menu-second-row-container",
				activeItems: items,
				actives: actives
			});
		} else {
			if (this.state.helpItemsBorderBottom !== null) {
				const items = this.state.menuItems[itemName].map((items, key) => {
					return (
						<div className="pt-3" key={key}>
							<Link className="main-menu-active-items" target={"_self"} to={items.data[0].link + items.link + "/" + items.data[0].text.split(" ").join("-") + "/" + items.data[0].id}>
								{items.title}
							</Link>
						</div>
					);
				});
				this.setState({
					activeItems: items,
					actives: actives
				});
			} else {
				this.setState({
					helpSubItemsActive: "d-none",
					helpItemsBorderBottom: null,
				});
			}
		}
	}
	render() {
		return (
			<header className="mapsa-header">
				<div className="container-fluid">
					<div className="">
						<div className="col-12 pt-3 mt-4 pl-5 pr-5">
							<div className="row direction-rtl mr-5 pr-4 smart-phone-header-logo">
								<div className="col-3 p-0">
									<ul className="nav direction-rtl text-right header-logo-ul">
										<li className="mapsa-top-menu-item font-weight-bold">
											<Link to={"/"}>مپســا</Link>
										</li>
										<li className="mapsa-top-menu-item font-weight-bold">|</li>
										<li className="mapsa-top-menu-navigation-text">
											<Link to={"/"}>
												راهنمای
												<span className="font-weight-bold"> نرم‌ افزار</span>
												{/*<span className="font-weight-bold">خانه</span>*/}
											</Link>
										</li>
									</ul>
								</div>
								<div className="col-7 pt-2 pr-0 pl-0">
									{this.headerSearch(this.props.hide || false)}
								</div>
								<div className="col-1 mt-0 smart-phone-menu-icon">
									<Popup
										onOpen={()=>( document.body.style.overflow = "hidden" )}
										onClose={()=>( document.body.style.overflow = "unset" )}
										trigger={<a href="javascript:void(0);" id="mapsa-menu-icon">&nbsp;</a>}
										modal
										closeOnDocumentClick
										closeOnEscape
										overlayStyle={{backgroundColor: '#2699FB'}}
										contentStyle={{width: "100%", height: "100%", backgroundColor: '#2699FB'}}
									>
										{(close) => (
											<div className="container pl-0 pr-5">
												<div className="row pt-1 mb-5">
													<div className="col-12 pt-3 mt-3 main-menu-top-bar-smart-phone">
														<div className="row direction-rtl">
															<div className="col-3 p-0 main-menu-top-bar-logo-smart-phone">
																<ul className="nav direction-rtl text-right">
																	<li className="mapsa-top-menu-item font-weight-bold">
																		<span className="menu-container-logo">مپســا</span>
																	</li>
																	<li className="mapsa-top-menu-item menu-container-logo font-weight-bold">|</li>
																	<li className="mapsa-top-menu-navigation-text">
																		<span className="menu-container-logo">
																			راهنمای
																			<span className="font-weight-bold"> نرم‌ افزار</span>
																		</span>
																	</li>
																</ul>
															</div>
															<div className="col-8 pt-2 main-menu-top-bar-smart-phone-middle-column">
																{}
															</div>
															<div className="col-1 mt-0">
																<a onClick={() => (close())} href="javascript:void(0);" id="mapsa-menu-close-icon">&nbsp;</a>
															</div>
															
														</div>
													</div>
												</div>
												<div className="row main-menu-items-container">
													<div className="col-12 pb-4 pl-0 pr-0 main-menu-item-container-first-row">
														<div className="row">
															<div className="col-6 font-weight-bold text-right pr-4 main-menu-top-row-items">
																<a href="http://mapsa.ir" target="_self" className="main-menu-top-row-items-link">
																	صفحه خانه
																</a>
															</div>
															<div className={`col-3 main-menu-top-row-items font-weight-bold text-left ${this.state.helpActive}`} onClick={this.handleClick}>
																{
																	(this.state.link === null) ? <span className="main-menu-top-row-items-link main-menu-top-row-items-link-active pointer">راهنما</span> : <Link target={"_self"} className="main-menu-top-row-items-link main-menu-top-row-items-link-active" to={this.state.link}><span className="pointer">راهنما</span></Link>
																}
															</div>
															<div className="col-3 main-menu-top-row-items main-menu-top-row-items-disabled font-weight-bold text-left pl-2">
																<Link to="/aboutus" target={"_self"} className="main-menu-top-row-items-link">درباره ما</Link>
															</div>
														</div>
													</div>
													<div className={`col-12 pt-4 pb-3 pl-0 pr-0 ${this.state.helpItemsActive} ${this.state.helpItemsBorderBottom}`}>
														<div className="row">
															<div className={`col-2 pl-0 pr-4 font-weight-bold text-center main-menu-bottom-row-items ${this.state.actives["payment-and-purchase"]}`} >
																<span className={"pointer main-menu-bottom-row-items-span"} onClick={this.subItemsHandleClick.bind(this, 'payment-and-purchase')}>
																	پرداخت ها
																</span>
															</div>
															<div className={`col-2 pl-0 pr-0 font-weight-bold text-center main-menu-bottom-row-items ${this.state.actives.receive}`} >
																<span className={"pointer main-menu-bottom-row-items-span"} onClick={this.subItemsHandleClick.bind(this, 'receive')}>
																	دریافت ها
																</span>
															</div>
															<div className={`col-2 pl-0 pr-0 font-weight-bold text-center main-menu-bottom-row-items ${this.state.actives.calender}`} >
																<span className={"pointer main-menu-bottom-row-items-span"} onClick={this.subItemsHandleClick.bind(this, 'calender')}>
																	تقویم
																</span>
															</div>
															<div className={`col-2 pl-0 pr-0 font-weight-bold text-center main-menu-bottom-row-items ${this.state.actives.functions}`} >
																<span className={"pointer main-menu-bottom-row-items-span"} onClick={this.subItemsHandleClick.bind(this, 'functions')}>
																	کارکرد ها
																</span>
															</div>
															<div className={`col-2 pl-0 pr-0 font-weight-bold text-center main-menu-bottom-row-items ${this.state.actives.reports}`} >
																<span className={"pointer main-menu-bottom-row-items-span"} onClick={this.subItemsHandleClick.bind(this, 'reports')}>
																	گزارش ها
																</span>
															</div>
															<div className={`col-2 pl-2 pr-0 font-weight-bold text-left main-menu-bottom-row-items pl-0 ${this.state.actives.setting}`} >
																<span className={"pointer main-menu-bottom-row-items-span"} onClick={this.subItemsHandleClick.bind(this, 'setting')}>
																	تنظیمات
																</span>
															</div>
														</div>
													</div>
													<div className={`col-12 mt-4 main-menu-third-row-container ${this.state.helpSubItemsActive}`}>
														<div className="row">
															<div className="col-4 main-menu-sub-items text-right">
																{
																	(this.state.activeItems.length === 0) ?
																		<div>
																			<div className="pt-3">
																				<Link className="main-menu-active-items" target={"_self"} to="/step-by-step/payment-and-purchase/خرید-نقدی/211">مواد و مصالح وپرداخت هزینه</Link>
																			</div>
																			<div className="pt-3">
																				<Link className="main-menu-active-items" target={"_self"} to="/step-by-step/payment-and-purchase/خرید-نقدی/224">ابزار و ماشین آلات</Link>
																			</div>
																			<div className="pt-3">
																				<Link className="main-menu-active-items" target={"_self"} to="/step-by-step/payment-and-purchase/پرداخت-حقوق-و-دستمزد/231">سایر</Link>
																			</div>
																		</div> :
																	this.state.activeItems
																}
															</div>
														</div>
													</div>
												</div>
											</div>
										)}
									</Popup>
								</div>
							</div>
						</div>
					</div>
				</div>
				{ (!this.props.hide) ? <hr className="header-border-bottom m-0 mt-4 pt-2"/> : null }
				<div className="container main-page-top-section-background-image-container">
					{this.breadCrumbs(this.props.hide || false)}
				</div>
			</header>
		);
	}
}

export default withRouter(Header);